let intervalId = null;
const watchers = new Map();
const prevJson = new Map();
export const watchArray = (arrayPath, callback) => {
	let arrayWatchers = watchers.get(arrayPath);
	if (!arrayWatchers) {
		arrayWatchers = new Set();
		watchers.set(arrayPath, arrayWatchers);
	}
	arrayWatchers.add(callback);
	clearInterval(intervalId);
	const doIt = () => {
		watchers.forEach((callbacks, path) => {
			let current = [];
			try {
				// eslint-disable-next-line no-eval
				const temp = eval(path) || [];
				if (temp) current = [...temp];
				// eslint-disable-next-line no-empty
			} catch (e) {} // If there is an error the path is invalid it and we should leave it as an empty array
			const json = JSON.stringify(current, (k, v) => {
				if (v instanceof Element) return v.outerHTML;
				if (k !== '' && v === current) return '[Circular Reference]';
				return v;
			});
			const prev = prevJson.get(path);
			if (json !== prev) {
				callbacks.forEach((cb) => cb(path, JSON.parse(json)));
				prevJson.set(path, json);
			}
		});
	};
	doIt();
	intervalId = setInterval(doIt, 100);
};
export const unwatchArray = (arrayPath, callback = false) => {
	if (!callback) {
		watchers.delete(arrayPath);
	} else {
		const arrayWatchers = watchers.get(arrayPath);
		if (arrayWatchers) {
			arrayWatchers.delete(callback);
			if (arrayWatchers.size < 1) watchers.delete(arrayPath);
		}
	}
};
